export default __webpack_public_path__ + "static/media/spaceShipB3.f8be8bcb.webp";